export const RemoveIconSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M10.5 2H8.95C8.83395 1.43571 8.52691 0.928673 8.08063 0.564359C7.63434 0.200045 7.0761 0.000727262 6.5 0L5.5 0C4.9239 0.000727262 4.36566 0.200045 3.91937 0.564359C3.47309 0.928673 3.16605 1.43571 3.05 2H1.5C1.36739 2 1.24021 2.05268 1.14645 2.14645C1.05268 2.24021 1 2.36739 1 2.5C1 2.63261 1.05268 2.75979 1.14645 2.85355C1.24021 2.94732 1.36739 3 1.5 3H2V9.5C2.00079 10.1628 2.26444 10.7982 2.73311 11.2669C3.20178 11.7356 3.8372 11.9992 4.5 12H7.5C8.1628 11.9992 8.79822 11.7356 9.26689 11.2669C9.73556 10.7982 9.99921 10.1628 10 9.5V3H10.5C10.6326 3 10.7598 2.94732 10.8536 2.85355C10.9473 2.75979 11 2.63261 11 2.5C11 2.36739 10.9473 2.24021 10.8536 2.14645C10.7598 2.05268 10.6326 2 10.5 2ZM5.5 1H6.5C6.81014 1.00038 7.11256 1.09669 7.36581 1.27572C7.61905 1.45476 7.81071 1.70775 7.9145 2H4.0855C4.18929 1.70775 4.38095 1.45476 4.63419 1.27572C4.88744 1.09669 5.18986 1.00038 5.5 1ZM9 9.5C9 9.89782 8.84196 10.2794 8.56066 10.5607C8.27936 10.842 7.89782 11 7.5 11H4.5C4.10218 11 3.72064 10.842 3.43934 10.5607C3.15804 10.2794 3 9.89782 3 9.5V3H9V9.5Z"
        fill="white"
      />
      <path
        d="M5 9C5.13261 9 5.25979 8.94732 5.35355 8.85355C5.44732 8.75979 5.5 8.63261 5.5 8.5V5.5C5.5 5.36739 5.44732 5.24021 5.35355 5.14645C5.25979 5.05268 5.13261 5 5 5C4.86739 5 4.74021 5.05268 4.64645 5.14645C4.55268 5.24021 4.5 5.36739 4.5 5.5V8.5C4.5 8.63261 4.55268 8.75979 4.64645 8.85355C4.74021 8.94732 4.86739 9 5 9Z"
        fill="white"
      />
      <path
        d="M7 9C7.13261 9 7.25979 8.94732 7.35355 8.85355C7.44732 8.75979 7.5 8.63261 7.5 8.5V5.5C7.5 5.36739 7.44732 5.24021 7.35355 5.14645C7.25979 5.05268 7.13261 5 7 5C6.86739 5 6.74021 5.05268 6.64645 5.14645C6.55268 5.24021 6.5 5.36739 6.5 5.5V8.5C6.5 8.63261 6.55268 8.75979 6.64645 8.85355C6.74021 8.94732 6.86739 9 7 9Z"
        fill="white"
      />
    </svg>
  );
};
